var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.736 7.7439L9.54323 15.0118C9.41218 15.1614 9.34595 15.357 9.3591 15.5555C9.37225 15.754 9.46371 15.9391 9.61335 16.0701C9.763 16.2012 9.95857 16.2674 10.157 16.2542C10.3555 16.2411 10.5406 16.1496 10.6717 16L16.856 8.74171L17.0597 11.8242C17.0729 12.0226 17.1644 12.2077 17.314 12.3387C17.4636 12.4697 17.6591 12.5359 17.8576 12.5228C18.056 12.5097 18.2411 12.4182 18.3721 12.2686C18.5031 12.119 18.5694 11.9234 18.5562 11.725L18.333 8.32442C18.3136 8.02946 18.2362 7.74123 18.1053 7.47619C17.9745 7.21115 17.7926 6.9745 17.5702 6.77975C17.3479 6.58501 17.0893 6.436 16.8093 6.34122C16.5293 6.24645 16.2334 6.20778 15.9384 6.22742L12.5396 6.45314C12.3412 6.46632 12.1561 6.55777 12.0251 6.70739C11.8941 6.857 11.8278 7.05253 11.8409 7.25097C11.8541 7.4494 11.9456 7.63448 12.0952 7.7655C12.2448 7.89652 12.4403 7.96276 12.6388 7.94964L15.736 7.7439Z",
    fill: "#26445A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.5L10 15.5",
    stroke: "#26445A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackTo);
export default __webpack_public_path__ + "static/media/BackTo.c154ff2b6a8e0fc1107d65e849a432f2.svg";
export { ForwardRef as ReactComponent };